module.exports = __webpack_public_path__ + "static/media/footer_btn_send.c2e5dfe5.svg";